import axios from './axios'
import moment from 'moment'
const momentFormats = [
  moment.ISO_8601,
  'DDMMYY',
  'DDMMYYYY',
  'YYMMDD',
  'YYYMMDD',
]

export const docsService = {
  getDocList,
}

const date1C = function(date) {
  const momentDate = moment(date, momentFormats)
  if (momentDate.isValid()) return moment(momentDate).format('YYYYMMDD')
  else return moment().format('YYYYMMDD')
}

async function getDocList(dateFrom, dateTo, archivedDocs) {
  function checkPeriod() {
    if (!moment(dateFrom).isValid()) {
      console.error(
        'При попытке получить данные используется некорректная дата начала:',
        dateFrom
      )
      return false
    }
    if (!moment(dateTo).isValid()) {
      console.error(
        'При попытке получить данные используется некорректная дата окончания:',
        dateTo
      )
      return false
    }
    if (moment(dateFrom).isAfter(dateTo)) {
      console.error(
        'При попытке получить данные используется некорректый период:',
        dateFrom,
        dateTo
      )
      return false
    }
    return true
  }
  if (!checkPeriod()) {
    return []
  }

  const date1CFrom = date1C(dateFrom)
  const date1CTo = date1C(dateTo)
  // console.log(
  //   'Получаем документы за период',
  //   date1CFrom,
  //   date1CTo,
  //   archivedDocs
  // )

  return await axios
    .request({
      url: '/OrdersDetails',
      params: {
        requestType: 0,
        startDate: date1CFrom,
        endDate: date1CTo,
        searchByNumber: false,
        archivedDocs,
      },
    })
    .then(resp => {
      if (resp.data.documents) {
        let docs = JSON.stringify(resp.data.documents)
        docs = JSON.parse(docs)
        return docs
      } else {
        return []
      }
    })
    .catch(e=>{
      return e
    })
}
